// utils/auth.js

const SUPER_ADMIN_USER_TYPE = 1;

/** True when the user is in "switch user" mode and the stored admin session was super admin. */
export const isSwitchedFromSuperAdminSession = (user) => {
  const admin = user?.admin;
  if (!admin) return false;
  if (admin.loginType === "superAdmin") return true;
  return admin?.user?.user_data?.user_type === SUPER_ADMIN_USER_TYPE;
};

export const isAuthenticated = (user) => {
  return Object.keys(user)?.length > 0; // Replace "authToken" with your key
};
